var render = function render(){
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5, _vm$item6, _vm$item7, _vm$item8, _vm$item9, _vm$item0, _vm$item1, _vm$item10, _vm$item11, _vm$item11$toolRelate, _vm$item12, _vm$item12$toolRelate, _vm$item13, _vm$item13$toolKnownC, _vm$item14, _vm$item14$toolKnownC;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Products & Services Details'
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'tool-list'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to All Products & Services ")])], 1)], 1)], 1), _c('section', {
    staticClass: "section section-blog p-0 mt-1 mb-3"
  }, [_c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'tool'
    }
  }), _c('div', {
    staticClass: "container-fluid px-xs-1 px-sm-1 px-md-5 px-lg-4 px-xl-4"
  }, [_c('article', [_c('div', {
    staticClass: "w-100 mb-3 mb-lg-5 mb-xl-5"
  }, [_c('b-row', {
    staticClass: "h-100"
  }, [_c('b-col', {
    staticClass: "d-flex flex-column justify-content-center",
    attrs: {
      "md": "4",
      "lg": "4",
      "xl": "4",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('img', {
    staticClass: "img-fluid img-thumbnail border-0 tool-logo",
    attrs: {
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.mainImage,
      "alt": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.photoDescription
    }
  })]), _c('b-col', {
    staticClass: "pb-0 pl-3 pl-lg-5 pl-xl-5",
    attrs: {
      "md": "8",
      "lg": "8",
      "xl": "8",
      "sm": "12",
      "xs": "12"
    }
  }, [_c('div', {
    staticClass: "company-info-name d-flex flex-column justify-content-start align-items-center align-items-lg-start align-items-xl-start pt-lg-4 pt-xl-4"
  }, [_vm._v(" " + _vm._s((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.toolCreatedBy) + " ")]), _c('div', {
    staticClass: "company-info-data d-flex flex-column justify-content-center justify-content-lg-end justify-content-xl-end",
    class: _vm.companyDataInfoClass
  }, [_c('div', {
    staticClass: "company-info-data-items"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Cost Model:")]), _c('div', {
    staticClass: "company-info-data-item-value"
  }, [_vm._v(_vm._s((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.toolCostModel))])]), _c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Ease of Use:")]), _c('div', {
    staticClass: "company-info-data-item-value"
  }, [_vm._v(_vm._s((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.toolEaseOfUse))])]), _c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Typical Users:")]), _c('div', {
    staticClass: "company-info-data-item-value",
    attrs: {
      "title": (_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : _vm$item6.toolTypicalUsers
    }
  }, [_c('span', {
    staticClass: "company-info-data-value-overflow"
  }, [_vm._v(_vm._s((_vm$item7 = _vm.item) === null || _vm$item7 === void 0 ? void 0 : _vm$item7.toolTypicalUsers))])])]), _c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Free Training Resources:")]), _c('div', {
    staticClass: "company-info-data-item-value"
  }, [((_vm$item8 = _vm.item) === null || _vm$item8 === void 0 ? void 0 : _vm$item8.toolFreeTrainingResourcesAvailable) === 'true' ? _c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "size": "lg",
      "icon": ['fas', 'check-circle']
    }
  }) : _c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "size": "lg",
      "icon": ['fas', 'times-circle']
    }
  })], 1)]), _c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Paid Training Resources:")]), _c('div', {
    staticClass: "company-info-data-item-value"
  }, [((_vm$item9 = _vm.item) === null || _vm$item9 === void 0 ? void 0 : _vm$item9.toolPaidTraining) === 'true' ? _c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "size": "lg",
      "icon": ['fas', 'check-circle']
    }
  }) : _c('font-awesome-icon', {
    staticClass: "pl-1",
    attrs: {
      "size": "lg",
      "icon": ['fas', 'times-circle']
    }
  })], 1)]), _c('div', {
    staticClass: "w-100 d-flex justify-content-start align-items-start company-info-data-item"
  }, [_c('div', {
    staticClass: "company-info-data-item-title"
  }, [_vm._v("Website:")]), _c('div', {
    staticClass: "company-info-data-item-value"
  }, [_c('a', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "target": "_blank",
      "href": (_vm$item0 = _vm.item) === null || _vm$item0 === void 0 ? void 0 : _vm$item0.toolWebsite
    }
  }, [_vm._v(" " + _vm._s((_vm$item1 = _vm.item) === null || _vm$item1 === void 0 ? void 0 : _vm$item1.toolWebsite) + " ")])])])])])])], 1)], 1), _c('div', {
    staticClass: "w-100 pt-1 mb-4"
  }, [_c('div', {
    staticClass: "w-100 my-3 company-description-header text-center text-lg-left text-xl-left"
  }, [_vm._v("About This Listing")]), _c('div', {
    staticClass: "company-description-text p-0"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s((_vm$item10 = _vm.item) === null || _vm$item10 === void 0 ? void 0 : _vm$item10.review)
    }
  })])]), _c('div', {
    staticClass: "w-100 mb-4"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "certs-and-client-row",
    attrs: {
      "xs": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "xl": "6"
    }
  }, [_c('p', {
    staticClass: "mb-0 title text-center text-lg-left text-xl-left"
  }, [_c('b', [_vm._v("Related Certifications")])]), _c('div', {
    staticClass: "company-certs-clients-container align-self-center align-self-lg-start align-self-xl-start"
  }, [((_vm$item11 = _vm.item) === null || _vm$item11 === void 0 ? void 0 : (_vm$item11$toolRelate = _vm$item11.toolRelatedCertifications) === null || _vm$item11$toolRelate === void 0 ? void 0 : _vm$item11$toolRelate.certification.length) > 0 ? _c('b-list-group', {
    staticClass: "w-100"
  }, _vm._l((_vm$item12 = _vm.item) === null || _vm$item12 === void 0 ? void 0 : (_vm$item12$toolRelate = _vm$item12.toolRelatedCertifications) === null || _vm$item12$toolRelate === void 0 ? void 0 : _vm$item12$toolRelate.certification, function (cert) {
    return _c('b-list-group-item', {
      key: cert
    }, [_vm._v(_vm._s(cert) + " ")]);
  }), 1) : _c('b-list-group', {
    staticClass: "w-100"
  }, [_c('b-list-group-item', [_vm._v("Certificates are unavailable")])], 1)], 1)]), _c('b-col', {
    staticClass: "certs-and-client-row",
    attrs: {
      "xs": "12",
      "sm": "12",
      "md": "6",
      "lg": "6",
      "xl": "6"
    }
  }, [_c('p', {
    staticClass: "mb-0 title text-center text-lg-left text-xl-left"
  }, [_c('b', [_vm._v("Known Clients")])]), _c('div', {
    staticClass: "company-certs-clients-container align-self-center align-self-lg-start align-self-xl-start"
  }, [((_vm$item13 = _vm.item) === null || _vm$item13 === void 0 ? void 0 : (_vm$item13$toolKnownC = _vm$item13.toolKnownClients) === null || _vm$item13$toolKnownC === void 0 ? void 0 : _vm$item13$toolKnownC.knownClient.length) > 0 ? _c('b-list-group', {
    staticClass: "w-100"
  }, _vm._l((_vm$item14 = _vm.item) === null || _vm$item14 === void 0 ? void 0 : (_vm$item14$toolKnownC = _vm$item14.toolKnownClients) === null || _vm$item14$toolKnownC === void 0 ? void 0 : _vm$item14$toolKnownC.knownClient, function (cert) {
    return _c('b-list-group-item', {
      key: cert
    }, [_vm._v(_vm._s(cert) + " ")]);
  }), 1) : _c('b-list-group', {
    staticClass: "w-100"
  }, [_c('b-list-group-item', [_vm._v("Clients are unavailable")])], 1)], 1)])], 1)], 1)])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }